import React from 'react';
import withTheme from './Layout/withTheme';
import {withIntl} from '../i18n';

import Error from "./Error";
import {setLocale} from 'yup';
import jupLocaleDE from '../i18n/yupLocaleDE';
import i18n from '../i18n';

class App extends React.Component {

    state = {
        error: null
    };

    componentDidMount() {
        if (i18n.getLocale() === 'de') {
            setLocale(jupLocaleDE);
        }
    }

    componentDidCatch(error, errorInfo) {
        this.setState({error});
        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });
    }

    render() {
        if (this.state.error) {
            // render fallback UI
            return (
                <Error
                    error={this.state.error}
                    onHomeClick={() => window.location = '/'}
                    onReportClick={() => Sentry.showReportDialog()}
                />
            );
        } else {
            // when there's not an error, render children untouched
            return this.props.children;
        }
    }
}

export default withIntl(withTheme(App));
